import {createSelector} from 'reselect';

export const getCommunitiesFromResults = createSelector(
	props => props.results,
	results =>
		results &&
		results.reduce((communities, provider) => {
			provider.memberships.forEach(membership => {
				communities[membership.uuid] = communities[membership.uuid] || membership;
				communities[membership.uuid].count = (communities[membership.uuid].count || 0) + 1;
			});
			return communities;
		}, {})
);

const MAX_PER_CATEGORY = 5;

export const getCategoryCommunitiesFromResults = createSelector(
	getCommunitiesFromResults,
	communities =>
		communities &&
		Object.keys(communities).reduce((categories, uuid) => {
			const community = communities[uuid];
			categories[community.category || 'Other'] = categories[community.category || 'Other'] || [];

			if (categories[community.category || 'Other'].length >= MAX_PER_CATEGORY) return categories;

			categories[community.category || 'Other'].push(community);
			return categories;
		}, {})
);

export const getCommunityFilterMap = createSelector(
	props => props.communityFilters,
	communityFilters =>
		communityFilters &&
		communityFilters.length &&
		communityFilters.reduce((obj, uuid) => {
			obj[uuid] = obj[uuid] || true;
			return obj;
		}, {})
);

export const getRelevantSuburbUUIDMap = createSelector(
	props => props.results,
	results =>
		results &&
		results.reduce((accum, result) => {
			if (!result.user || !result.user.location) return undefined;
			accum[result.user.location.suburbUuid] = true;
			return accum;
		}, {})
);

export const getRelevantCommunitySuburbUUIDMap = createSelector(
	props => props.results,
	results =>
		results &&
		results.reduce((accum, result) => {
			if (!result || !result.location) return undefined;
			accum[result.location.suburbUuid] = true;
			return accum;
		}, {})
);

export const getRelevantSuburbs = createSelector(
	getRelevantSuburbUUIDMap,
	props => props.suburbs, //suburbUuid
	(relevantUUIDMap, suburbs) =>
		relevantUUIDMap && suburbs && suburbs.filter(suburb => relevantUUIDMap[suburb.suburbUuid])
);

export const getRelevantCommunitySuburbs = createSelector(
	getRelevantCommunitySuburbUUIDMap,
	props => props.suburbs, //suburbUuid
	(relevantUUIDMap, suburbs) =>
		relevantUUIDMap && suburbs && suburbs.filter(suburb => relevantUUIDMap[suburb.suburbUuid])
);

export const getProviderFilteredResults = createSelector(
	props => props.results,
	props => props.suburbFilter,
	getCommunityFilterMap,
	(results, suburbFilter, communityFilterMap) =>
		results
			? results.filter(
					result =>
						(!communityFilterMap ||
							!!result.memberships.find(community => communityFilterMap[community.uuid])) &&
						(!suburbFilter || result.user.location.suburbUuid === suburbFilter)
			  )
			: results
);

// export const getUserFilteredResults = createSelector(
// 	props => props.results,
// 	props => props.suburbFilter,
// 	(results, suburbFilter) => (
// 		results ? results.filter(
// 			result => (
// 				(!suburbFilter || result.user.location.suburbUuid === suburbFilter)
// 			)
// 		) : results
// 	)
// );

export const getCommunityFilteredResults = createSelector(
	props => props.results,
	props => props.suburbFilter,
	(results, suburbFilter) =>
		results
			? results.filter(result => !suburbFilter || result.location.suburbUuid === suburbFilter)
			: results
);

export const getFilteredSuburb = createSelector(
	props => props.suburbs,
	props => props.suburbFilter,
	(suburbs, suburbFilter) =>
		suburbFilter && suburbs && suburbs.find(suburb => suburb.suburbUuid === suburbFilter)
);



// WEBPACK FOOTER //
// ./src/search/search.selectors.js